import React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation, Trans } from 'react-i18next';
import { useTheme } from '@mui/material';
import { MarketButton } from '@market/react';
import ControlledInputText from 'components/common/forms/controlled_input_text';
import {
  VERIFY_IDENTITY,
  buildSignInLink,
  buildSignUpLink,
} from 'utilities/links';
import { onCartPageClick } from 'components/pages/cart/utilities';

const PromoAdd = (props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const {
    control,
    setError,
    handleSubmit,
    formState: { isSubmitting, errors },
  } = useForm();

  const { cartClient, orderRefresh } = props;

  const STATUS_CODE_TO_URL = {
    no_user_specified: buildSignInLink({ returnTo: true }),
    incomplete_idv: buildSignUpLink({ returnTo: true, step: VERIFY_IDENTITY }),
  };

  const getLinkComponent = (status_code) => {
    if (!Object.keys(STATUS_CODE_TO_URL).includes(status_code)) return null;

    const url = STATUS_CODE_TO_URL[status_code];

    return {
      url: (
        <a
          href={url}
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: 'underline' }}
        />
      ),
    };
  };

  const errorDisplay = () => {
    if (Object.keys(errors).length === 0) return null;

    const status_code = errors.promoCode.status_code;
    const linkComponent = getLinkComponent(status_code);

    if (!linkComponent) return null;

    return (
      <Trans
        className="paragraph-20"
        i18nKey={`error.promotion.${status_code}`}
        parent={'div'}
        components={linkComponent}
        style={{
          color: theme.color.error,
        }}
      />
    );
  };

  const submit = (data) => {
    onCartPageClick({
      actionItem: 'promo_code_attempt',
      additionalParameters: {
        code: data['promoCode'],
      },
    });

    cartClient.addPromotion(data['promoCode']).then(
      () => {
        orderRefresh();
        onCartPageClick({
          actionItem: 'add_promo_code',
          additionalParameters: {
            code: data['promoCode'],
          },
        });
      },
      (error) =>
        setError('promoCode', {
          message: error.message,
          status_code: error.status_code,
        }),
    );
  };

  return (
    <form id="add-promo-form" onSubmit={handleSubmit(submit)}>
      <ControlledInputText
        shouldUnregister
        control={control}
        cta={errorDisplay()}
        label={t('cart.label.promoCode')}
        name="promoCode"
        rules={{ required: true }}
      >
        <MarketButton
          {...(isSubmitting && { disabled: true })}
          id="add-promo-btn"
          rank="secondary"
          size="small"
          slot="trailing-accessory"
          type="submit"
        >
          {t('cart.label.apply')}
        </MarketButton>
      </ControlledInputText>
    </form>
  );
};

export default PromoAdd;
